import { Typography } from '@remarkable/ark-web';
import { ComponentLocations } from 'src/analytics/trackingTypes';
import { useRequestToCancelEnterpriseSubscription } from 'src/api/queries/enterpriseSubscription';
import { Button, Divider, Modal, NotificationBox } from 'src/components';

export function CancelEnterpriseSubscriptionModal({
  onSuccess,
}: {
  onSuccess: () => void;
}) {
  const requestToCancelSubscription =
    useRequestToCancelEnterpriseSubscription();

  return (
    <Modal.Content className="flex flex-col gap-24">
      <Modal.Title asChild>
        <Typography variant="fluid-heading-xl" as="h1">
          Cancel Subscription
        </Typography>
      </Modal.Title>

      <Divider />

      <Modal.Description asChild>
        <div className="flex w-full flex-col gap-16 text-left">
          <Typography variant="body-md">
            You&apos;re about to cancel your company&apos;s subscription.
          </Typography>

          <ul className="flex list-disc flex-col pl-20">
            <li>
              <Typography variant="body-md">
                You&apos;ll continue to have access until the end of the current
                billing period.
              </Typography>
            </li>
            <li>
              <Typography variant="body-md">
                Your subscription won&apos;t renew after that date.
              </Typography>
            </li>
            <li>
              <Typography variant="body-md">
                No further payments will be charged once the current period
                ends.
              </Typography>
            </li>
            <li>
              <Typography variant="body-md">
                You can reactivate anytime before your current period ends.
              </Typography>
            </li>
          </ul>
        </div>
      </Modal.Description>

      <div className="flex flex-col items-center justify-center gap-16 sm:flex-row">
        <Modal.Close asChild>
          <Button
            variant="secondary"
            className="w-full sm:w-fit"
            analytics={{
              text: 'Keep subscription',
              location: ComponentLocations.ENTERPRISE.BILLING_PAGE,
              action: 'close request to cancel enterprise subscription modal',
            }}
          >
            Keep subscription
          </Button>
        </Modal.Close>
        <Button
          variant="primary"
          className="w-full sm:w-fit"
          onClick={() => {
            requestToCancelSubscription.mutate(undefined, { onSuccess });
          }}
          analytics={{
            text: 'Confirm cancellation',
            location: ComponentLocations.ENTERPRISE.BILLING_PAGE,
            action: 'request to cancel enterprise subscription',
          }}
          disabled={requestToCancelSubscription.isPending}
          loading={requestToCancelSubscription.isPending}
        >
          Confirm cancellation
        </Button>
      </div>

      <NotificationBox error={requestToCancelSubscription.error} />
    </Modal.Content>
  );
}
